export const getDiscountData = (state) => {
  const discountData = state.pages.shop.discounts;
  return discountData;
};
